/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ResourceTypeDto } from '../models';
/**
 * RestResourcesThreadApi - axios parameter creator
 */
export const RestResourcesThreadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} emailThreadId 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addThread: async (emailThreadId: string, resourceId: string, resourceType: ResourceTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailThreadId' is not null or undefined
            assertParamExists('addThread', 'emailThreadId', emailThreadId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('addThread', 'resourceId', resourceId)
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('addThread', 'resourceType', resourceType)
            const localVarPath = `/api/resources/{resourceId}/email-threads/{emailThreadId}`
                .replace('{emailThreadId}', encodeURIComponent(String(emailThreadId)))
                .replace('{resourceId}', encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (resourceType !== undefined) {
                localVarQueryParameter['resourceType'] = resourceType;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} emailThreadId 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeThread: async (emailThreadId: string, resourceId: string, resourceType: ResourceTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailThreadId' is not null or undefined
            assertParamExists('removeThread', 'emailThreadId', emailThreadId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('removeThread', 'resourceId', resourceId)
            // verify required parameter 'resourceType' is not null or undefined
            assertParamExists('removeThread', 'resourceType', resourceType)
            const localVarPath = `/api/resources/{resourceId}/email-threads/{emailThreadId}`
                .replace('{emailThreadId}', encodeURIComponent(String(emailThreadId)))
                .replace('{resourceId}', encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (resourceType !== undefined) {
                localVarQueryParameter['resourceType'] = resourceType;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestResourcesThreadApi - functional programming interface
 */
export const RestResourcesThreadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestResourcesThreadApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} emailThreadId 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addThread(emailThreadId: string, resourceId: string, resourceType: ResourceTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addThread(emailThreadId, resourceId, resourceType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestResourcesThreadApi.addThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} emailThreadId 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeThread(emailThreadId: string, resourceId: string, resourceType: ResourceTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeThread(emailThreadId, resourceId, resourceType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestResourcesThreadApi.removeThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestResourcesThreadApi - factory interface
 */
export const RestResourcesThreadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestResourcesThreadApiFp(configuration)
    return {
        /**
         * 
         * @param {string} emailThreadId 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addThread(emailThreadId: string, resourceId: string, resourceType: ResourceTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addThread(emailThreadId, resourceId, resourceType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} emailThreadId 
         * @param {string} resourceId 
         * @param {ResourceTypeDto} resourceType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeThread(emailThreadId: string, resourceId: string, resourceType: ResourceTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeThread(emailThreadId, resourceId, resourceType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestResourcesThreadApi - interface
 */
export interface RestResourcesThreadApiInterface {
    /**
     * 
     * @param {string} emailThreadId 
     * @param {string} resourceId 
     * @param {ResourceTypeDto} resourceType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addThread(emailThreadId: string, resourceId: string, resourceType: ResourceTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {string} emailThreadId 
     * @param {string} resourceId 
     * @param {ResourceTypeDto} resourceType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeThread(emailThreadId: string, resourceId: string, resourceType: ResourceTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestResourcesThreadApi - object-oriented interface
 */
export class RestResourcesThreadApi extends BaseAPI implements RestResourcesThreadApiInterface {
    /**
     * 
     * @param {string} emailThreadId 
     * @param {string} resourceId 
     * @param {ResourceTypeDto} resourceType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addThread(emailThreadId: string, resourceId: string, resourceType: ResourceTypeDto, options?: RawAxiosRequestConfig) {
        return RestResourcesThreadApiFp(this.configuration).addThread(emailThreadId, resourceId, resourceType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} emailThreadId 
     * @param {string} resourceId 
     * @param {ResourceTypeDto} resourceType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeThread(emailThreadId: string, resourceId: string, resourceType: ResourceTypeDto, options?: RawAxiosRequestConfig) {
        return RestResourcesThreadApiFp(this.configuration).removeThread(emailThreadId, resourceId, resourceType, options).then((request) => request(this.axios, this.basePath));
    }
}

